// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"9c782ea0","387":"858d06b1","409":"84427eb9","436":"44b68381","453":"e1ed1f42","598":"c57348b2","678":"51e0b472","866":"6b358bc2","879":"7c9b2883","896":"1989d72e","951":"2aa0dc0c","967":"25e3dcea"}[chunkId] + ".chunk.js";
};